<script type="text/ecmascript-6">
    export default {
        props: {
            statistics: Object,
        },
        data() {
            return {
            }
        },
    }
</script>
<template>
    <div class="row">
        <label class="col-sm-4 control-label">Statistics</label>
        <div class="col-sm-4">
            <div class="checkbox" v-for="(value, name) in statistics">
                <span class="font-bold" v-text="name+':'"></span>
                <span v-if="value > 0" v-text="value"></span>
                <span v-else>none</span>
            </div>
        </div>
    </div>
</template>
